var map = {
	"./maps_badi.jpg": 141,
	"./maps_bindella.jpg": 142,
	"./maps_burkhalter.jpg": 143,
	"./maps_gastrokultur.jpg": 144,
	"./maps_raj.jpg": 145,
	"./maps_sportgastro.jpg": 146,
	"./maps_taberna.jpg": 147,
	"./maps_twospice.jpg": 148,
	"./maps_zfv.jpg": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;